// 使用方式
const USE_METHODS = {
  1: '拣选库位',
  2: '存储库位',
  3: '次品库位'
}
// 仓库库位
const WAREHOUSE_LOCATION_TYPE = {
  1: '货架',
  2: '地堆'
}

const WAREHOUSE_LOCATION_TYPE_LSIT = [
  { id: 1, name: '货架'},
  { id: 2, name: '地堆'},
]
const USE_METHODS_LIST = [
  { id: 1, name: '拣选库位'},
  { id: 2, name: '存储库位'},
  { id: 3, name: '次品库位'},
]

// 退货登记状态
const RETURN_REGISTER_STATUS = {
  0: '未处理',
  1: '已处理'
}
const RETURN_REGISTER_STATUS_LIST = [
  { id: 0, name: '未处理' },
  { id: 1, name: '已处理' }
]

// 退货报表状态集合
const RETURN_LIST_STATUS_LIST = [
  { id: 1, name: '待开单' },
  { id: 2, name: '待入库' },
  { id: 3, name: '入库完成' },
]
const RETURN_LIST_STATUS = {
  1: '待开单',
  2: '待入库',
  3: '入库完成'
}

// 考勤集合
const ATTENDANCE_LIST = [
  {
    id: 1,
    name: "是"
  },
  {
    id: 0,
    name: "否"
  }
]

// 分摊规则集合
const SHARE_TYPE_LIST = [
  {
    id: 1,
    name: "订单比例"
  },
  {
    id: 2,
    name: "订单复杂度"
  }
]
// 计费类型
const EXPRESS_TYPE = {
  1: '计重',
  2: '现场定价',
  3: '计体积'
}
// 计费类型集合
const EXPRESS_TYPE_LIST = [
  { id: 1, name: '计重'},
  { id: 2, name: '现场定价'},
  { id: 3, name: '计体积'},
]

// 处理方案
const DEAL_METHOD = {
  1: '补发',
  2: '退差价',
  3: '退款',
}
// 责任归属
const RESPONSIBLE_PARTY = {
  1: '仓库',
  2: '物流',
  3: '无'
}
export default {
  data() {
    return {
      USE_METHODS,
      WAREHOUSE_LOCATION_TYPE,
      WAREHOUSE_LOCATION_TYPE_LSIT,
      USE_METHODS_LIST,
      RETURN_REGISTER_STATUS,
      RETURN_REGISTER_STATUS_LIST,
      RETURN_LIST_STATUS_LIST,
      RETURN_LIST_STATUS,
      ATTENDANCE_LIST,
      SHARE_TYPE_LIST,
      EXPRESS_TYPE,
      EXPRESS_TYPE_LIST,
      DEAL_METHOD,
      RESPONSIBLE_PARTY
    }
  },
  created() {
  },
  methods: {
  }
}